import { render, staticRenderFns } from "./paragraph_setting.vue?vue&type=template&id=06081b21&"
import script from "./paragraph_setting.vue?vue&type=script&lang=js&"
export * from "./paragraph_setting.vue?vue&type=script&lang=js&"
import style0 from "./paragraph_setting.vue?vue&type=style&index=0&id=06081b21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports